import { FairyLoader, RES, Resize, UILayer } from '@pawgame/laya-game-sdk';
import { getVersionURL } from './getVersionURL';
let bg;
function setBG(url) {
    if (!bg) {
        bg = new FairyLoader();
        bg.align = 'center';
        bg.verticalAlign = 'middle';
        bg.setSize(Resize.getWidth(), Resize.getHeight());
    }
    if (url) {
        UILayer.inst.getUIRoot().addChildAt(bg, 0);
        const realURL = getVersionURL(url);
        RES.load(realURL).then(() => {
            bg.content.texture = Laya.loader.getRes(realURL);
        });
    }
    else {
        bg.url = null;
        bg.removeFromParent();
    }
}
function changeEmpty() {
    setBG(null);
}
export const SceneBG = {
    setBG,
    changeEmpty,
};
//# sourceMappingURL=SceneBG.js.map